// `selections` is the full prospective selection list - what the plan table would hold once the
// pending click is applied - so adding a plan and changing an already selected plan's options
// are both measured the same way.
export function isPlanTableMaxHeightExceeded(selections, plans, maxHeight, includeRestrictionNotes, restrictionNotesTextForHeightCalc) {
	const cellStyle =
		'font-size: 13px; font-weight: 400; padding: 2px;line-height: 19.5px;text-wrap-mode: wrap; word-break: break-word;font-family: Arial; max-width: 270px';
	const tempTable = document.createElement('div');
	let planCount = 0;
	tempTable.style.visibility = 'hidden';
	tempTable.style.position = 'absolute';
	tempTable.style.left = '-9999px';

	document.body.appendChild(tempTable);
	for (const selection of selections) {
		const plan = plans.find((p) => p.data.planId === selection.planId);
		// the notes only take up space for the plans the user chose to print them for
		const withNotes = includeRestrictionNotes && hasSelectedRestrictionNotes(selection);
		const row = createRow(plan, cellStyle, withNotes, restrictionNotesTextForHeightCalc);
		tempTable.appendChild(row);
		planCount++;
	}

	const height = tempTable.offsetHeight;
	document.body.removeChild(tempTable);
	console.log('Calculated table height:', height, ' for ', planCount, 'plans');
	return height > maxHeight;
}

export function hasSelectedRestrictionNotes(selection) {
	return selection.includeRestrictions || selection.includeCompetitiveRestrictionNotes?.some((p) => p.includeRestrictions) || false;
}

function createRow(plan, cellStyle, withRestrictionNotes, restrictionNotesTextForHeightCalc) {
	const row = document.createElement('div');
	const cell = document.createElement('div');
	cell.style = cellStyle;
	cell.innerHTML = plan.data.name || '';
	row.appendChild(cell);
	if (withRestrictionNotes) {
		const notesCell = document.createElement('div');
		notesCell.style = cellStyle;
		const restrictionNotes = plan.data.formularyRestriction || '';
		// only substitute the configured text for plans that actually render notes, otherwise
		// note-less plans get measured as if they had notes and the height trips early
		notesCell.innerHTML = restrictionNotes ? restrictionNotesTextForHeightCalc || restrictionNotes : '';
		row.appendChild(notesCell);
	}
	return row;
}
